import { render, staticRenderFns } from "./WidgetPatioStats.vue?vue&type=template&id=80af2186&"
import script from "./WidgetPatioStats.vue?vue&type=script&lang=js&"
export * from "./WidgetPatioStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports